import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import store from '@/store/store'
import 'vuetify/src/stylus/app.styl'
const config = require('../../../config/config.json')

if(store.state.currentOrg !==null){
  Vue.use(Vuetify, {
    iconfont: 'md',
    theme: {
      primary: '#99cc33',
      secondary: '#99cc33',
      tertiary: '#495057',
      navbarColour: '#31322F',
      navbarTextColour: '#ffffff',
      gluePrimary: '#99cc33',
      tick: '#3cde54',
      cancel: '#f01a1a',
      accent: '#82B1FF',
      error: '#f55a4e',
      info: '#00d3ee',
      success: '#5cb860',
      warning: '#ffa21a'
    }
  })
}
